export const localUsers = {
    addUser: (userData) => {
        let users = {};
        let dbUsers = localdb.get("user_map");
        if (dbUsers) {
            users = JSON.parse(dbUsers);
        }
        users[userData.id] = userData;
        localdb.put("user_map", JSON.stringify(users));
    },
    getAllUsers: () => {
        let dbUsers = localdb.get("user_map");
        if (dbUsers) {
            return JSON.parse(dbUsers);
        }
    },
    getUser: (userId) => {
        let dbUsers = localdb.get("user_map");
        if (dbUsers) {
            return JSON.parse(dbUsers)[userId];
        }
    },
    deleteUser: (userId) => {
        let dbUsers = localdb.get("user_map");
        if (dbUsers) {
            let users = JSON.parse(dbUsers);
            delete users[userId];
            localdb.put("user_map", JSON.stringify(users));
        }
    },
    setActiveUser: (userData) => {
        localdb.put("activeUser", JSON.stringify(userData));
    },
    getActiveUser: () => {
        return JSON.parse(localdb.get("activeUser"));
    },
    clearActiveUser: () => {
        localdb.remove("activeUser");
    },
}

export const tourPagesDb = {
    add: (pageName) => {
        let touredPages = localdb.get("tour_pages");
        if(touredPages){
             touredPages = JSON.parse(touredPages);
        }else{
           touredPages = [] ;
        }
        touredPages.push(pageName);
        localdb.put("tour_pages", JSON.stringify(touredPages));
    },

    get: (pageName) => {
        let touredPages = localdb.get("tour_pages");
        if(touredPages){
            touredPages = JSON.parse(touredPages);
            return touredPages.find((page)=> page === pageName);
        }
    }
}


export const localdb = {
    put: (k, v) => {
        localStorage.setItem(buildKey(k), v)
    },
    get: (k) => {
        return localStorage.getItem(buildKey(k));
    },
    remove: (k) => {
        localStorage.removeItem(buildKey(k));
    },
    getKey: (k) => {
        return buildKey(k);
    }
}

const buildKey = (key) => {
    let prefix = "TF_";
    if (process.env.NODE_ENV === "development") {
        prefix += "DEV_"
    }
    return prefix + key;
}